import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { RdtDetalle } from '@/types/api';

// Detalle completo de UNA RDT (GET /api/rdts/:id) — se pide recién al
// seleccionar una card (ficha + Actividad), no en el listado de la obra.
// `enabled` en null evita el request mientras no hay selección.
export function useRdt(id: number | null) {
  return useQuery({
    queryKey: ['rdt', id],
    queryFn: () => api<RdtDetalle>(`/api/rdts/${id}`),
    enabled: id !== null,
    staleTime: 15_000,
  });
}
